import React, { useContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { ConnectionAwareBackButton } from './ConnectionStatusBlip';
import { Grid, Container, Typography, Dialog, DialogActions, DialogTitle, Fab, CircularProgress, Box } from '@mui/material';
import { NavMenu } from './NavMenu';
import WebcamCapture from './WebcamComponent';
import CnoPhotoContext from '../contexts/CnoPhotoContext';
import StopsContext from '../contexts/StopsContext';
import FieldActivityContext from '../contexts/FieldActivityContext';
import PWDService from '../utils/apiClient';
import FieldActivityFinder from '../utils/updateHelper';
import { Cancel } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';
import CheckIcon from '@mui/icons-material/Check';
import { green } from '@mui/material/colors';
import { useSnackbar } from 'notistack';
import Moment from 'moment';

const PhotoCaptureScreenHeader = (props) => {
    return (
        <NavMenu>
            <ConnectionAwareBackButton />
            <Typography sx={{ flexGrow: 1, textAlign: 'center', paddingLeft: '15px'}}>
                {props.title}
            </Typography>
        </NavMenu>
    );
};

//TODO: update use of deprecated disableBackdropClick
const ConfirmPhotoSaveDialog = (props) => {

    const { onClose, open, onClickYes, success, loading } = props;

    const { cnoPhoto } = useContext(CnoPhotoContext);

    const handleClose = () => {
        onClose();
    };

    const handleConfirm = () => {
        onClickYes();
    };

    return (
        <Dialog
            disableEscapeKeyDown
            //fullWidth={true}
            maxWidth={false}
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
        >
            <DialogTitle id="alert-dialog-title">
                Use this photo?
            </DialogTitle>
                <div style={{ textAlign: "center" }}>
                    <img src={cnoPhoto} alt="container not out" height="75%" width="75%" />
                </div>
            <DialogActions className="photo-dialog-choice" sx={{ padding: "24px" }}>
                <div id="cancelWrapper" style={{ flex: 1 }}>
                    <Fab
                        aria-label="cancel"
                        color="error"
                        onClick={handleClose}
                    >
                        <Cancel />
                    </Fab>
                </div>
                <div style={{ position: 'relative' }}>
                    <Fab
                        arial-label="save"
                        color={ success ? "success" : "primary" }
                        diabled={loading.toString()}
                        onClick={handleConfirm}
                    >
                        {success ? <CheckIcon /> : <SaveIcon /> }
                    </Fab>
                    {loading && <CircularProgress size={68} sx={{ color: green[500], position: 'absolute', zIndex: 1, top: '-6px', left: '-6px' }} /> }
                </div>
            </DialogActions>
        </Dialog>
    );
};

ConfirmPhotoSaveDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

const PhotoCaptureScreen = () => {

    const { cnoPhoto, setCnoPhoto } = useContext(CnoPhotoContext);
    const { fieldActivityId } = useContext(FieldActivityContext);
    const [success, setSuccess] = useState(false);
    const { stops, setStops } = useContext(StopsContext);
    const [open, setOpen] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    let faObj = stops.find(({FieldActivityId}) => FieldActivityId === fieldActivityId);

    const [loading, setLoading] = useState(false);
    const timer = useRef();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCnoPhoto(null);
    };
    var swcId;
    var incidentId;
    var photoId;

    // const handleDummyClick = () => {
    //     console.log("in handle dummy click");
    //     setLoading(true);
    //     setSuccess(false);

    //     setTimeout(() => {
    //         let message = 'Photo successfully uploaded';
    //         enqueueSnackbar(message, {
    //             variant: 'success',
    //         });
    //         setLoading(false);
    //         setSuccess(true);
    //     }, 2500);
    // };

    const handleConfirmClick = () => {
        if (!loading){
            setLoading(true);
            setSuccess(false);

            const fetchData = async () => {
                const result = await PWDService.getSwcAndIncidentIDs(faObj.ServiceRequestNumber);
                return result;
            };

            if (faObj.SolidWasteContainerId !== null && faObj.ServiceRequestId !== null) {
                //we already have the swc IDs, so skip calling the flow again

                //then call upload photo
                let timeStamp = Moment().format('YYYY-MM-DD-HH-mm-ss');
                const postUploadCnoPhoto = async () => {
                    const result = await PWDService.uploadCnoPhoto(faObj.ServiceRequestNumber, cnoPhoto, faObj.SolidWasteContainerId, timeStamp);
                    return result;
                };
                postUploadCnoPhoto().then((photoValueResponse) => {
                    if (photoValueResponse.status === 200) {
                        //if we successfully got back the sharepoint file ItemId
                        if (photoValueResponse.data.itemId) {
                            //update the photo id prop from response value
                            photoId = photoValueResponse.data.itemId;
                            const newStops = [...stops];
                            let faForUpdate = FieldActivityFinder(newStops, fieldActivityId);
                            //faForUpdate.update.SolidWasteContainerId = swcId;
                            //faForUpdate.update.ServiceRequestId = incidentId;
                            faForUpdate.update.SharePointPhotoId = photoId;
                            faForUpdate.update.CnoPhoto = cnoPhoto;

                            newStops[faForUpdate.index] = faForUpdate.update;
                            setStops(newStops);
                            setLoading(false);
                            setSuccess(true);
                            //give a slight delay to modal window close
                            timer.current = window.setTimeout(() => {
                                //clear the CNO photo context
                                setCnoPhoto(null);
                                setOpen(false);
                            }, 1500);
                            let message = 'Photo successfully uploaded';
                            enqueueSnackbar(message, {
                                variant: 'success',
                            });
                        } else {
                            //there was an error
                            setLoading(false);
                            console.log("Error after posting photo to sharepoint");
                            let message = 'Error in photo upload response';
                            enqueueSnackbar(message, {
                                variant: 'error',
                            });
                        }
                    } else {
                        //network or other error
                        let message = 'Network error - Failed to upload photo';
                        enqueueSnackbar(message, {
                            variant: 'error',
                        });
                        setLoading(false);
                    }
                });
            } else {
                //we don't have the swc ID values yet
                fetchData().then((swcIdsResponse) => {
                    if (swcIdsResponse.status === 200) {
                        //if we successfully get back the swc Ids
                        swcId = swcIdsResponse.data.swcId;
                        incidentId = swcIdsResponse.data.incidentId;
                        //then call upload photo
                        let timeStamp = Moment().format('YYYY-MM-DD-HH-mm-ss');
                        const postUploadCnoPhoto = async () => {
                            const result = await PWDService.uploadCnoPhoto(faObj.ServiceRequestNumber, cnoPhoto, swcId, timeStamp);
                            return result;
                        };
                        postUploadCnoPhoto().then((photoValueResponse) => {
                            if (photoValueResponse.status === 200) {
                                //if we successfully got back the sharepoint file ItemId
                                if (photoValueResponse.data.itemId) {
                                    //update the photo id prop from response value
                                    photoId = photoValueResponse.data.itemId;
                                    const newStops = [...stops];
                                    let faForUpdate = FieldActivityFinder(newStops, fieldActivityId);
                                    faForUpdate.update.SolidWasteContainerId = swcId;
                                    faForUpdate.update.ServiceRequestId = incidentId;
                                    faForUpdate.update.SharePointPhotoId = photoId;
                                    faForUpdate.update.CnoPhoto = cnoPhoto;

                                    newStops[faForUpdate.index] = faForUpdate.update;
                                    setStops(newStops);
                                    setLoading(false);
                                    setSuccess(true);
                                    //give a slight delay to modal window close
                                    timer.current = window.setTimeout(() => {
                                        //clear the CNO photo context
                                        setCnoPhoto(null);
                                        setOpen(false);
                                    }, 1500);
                                    let message = 'Photo successfully uploaded';
                                    enqueueSnackbar(message, {
                                        variant: 'success',
                                    });
                                } else {
                                    //there was an error
                                    setLoading(false);
                                    console.log("Error after posting photo to sharepoint");
                                    let message = 'Error in photo upload response';
                                    enqueueSnackbar(message, {
                                        variant: 'error',
                                    });
                                }
                            } else {
                                //network or other error
                                let message = 'Network error - Failed to upload photo';
                                enqueueSnackbar(message, {
                                    variant: 'error',
                                });
                                setLoading(false);
                            }
                        });
                    } else {
                        console.log("Error calling flow to get SWC Ids");
                    }
                });
            }
        }
    };
    return (

        <React.Fragment >
            <Container style={{ backgroundColor:'#33333d', height:'inherit', overflow:'scroll', paddingRight:0, paddingLeft:0}} maxWidth={false}>
                <Box id="PhotoCaptureScreen" sx={{ flexGrow: 1 }}>
                <PhotoCaptureScreenHeader title="Route Stop Photo Mode"/>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                        style={{textAlign: 'center', paddingTop: '80px' }}
                    >
                    <WebcamCapture setDialogOpen={handleClickOpen} />
                    <ConfirmPhotoSaveDialog success={success} open={open} onClickYes={handleConfirmClick} onClose={handleClose} loading={loading} />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
};

export default PhotoCaptureScreen;